// extracted by mini-css-extract-plugin
module.exports = {"prop":"prop_prop__2ujMu","propLabel":"prop_propLabel__2ez1L","propValue":"prop_propValue__PXIjv"};